import { sendZapierWebhook } from "../api";
import {
  createTourFormZapierBody,
  partnerizePixel,
  openCalendlyNotModal,
} from "./util";
import { calendly } from "../../calendly";
import { app, DEVELOPMENT } from "../../../../../config/env";

const getTourLink = (size, tourLink, enterpriseLink, tourLinkOverride) => {
  if (tourLinkOverride) {
    return tourLinkOverride;
  }

  if (size === "1-4" || size === "5-19") {
    return tourLink;
  }

  if (enterpriseLink) {
    return enterpriseLink;
  }

  return tourLink;
};

const calendlyListener = (formValues, openModalNotCalendly) => () => {
  //  Zapier Hook
  const zapierBody = createTourFormZapierBody(formValues);
  sendZapierWebhook(zapierBody);

  //  partnerize
  partnerizePixel();

  //  deregister listener
  openModalNotCalendly;

  $("body").addClass("js-calendly-send");
};

export const loadCalendly = ($form, formName, formValues) => {
  const {
    FirstName,
    Email,
    LastName,
    Office_Size2__c,
    tour_link,
    tour_enterprise_link,
    tour_link_override,
    Company,
    Phone,
    schedule_a_call_link,
  } = formValues;

  const tourLink = getTourLink(
    Office_Size2__c,
    tour_link,
    tour_enterprise_link,
    tour_link_override
  );

  //  if it's scheduleForm then use scheduleCallLink
  //  otherwise we use the tourLink
  //  this check needs to be here because openModalNotCalendly uses the tour link as the default
  let calendlyLink =
    formName === "scheduleCallForm"
      ? schedule_a_call_link // eslint-disable-line indent
      : tourLink; // eslint-disable-line indent

  let showThankYou = calendlyLink === "show-thank-you";

  if (
    window.location.href.indexOf("local.") > -1 ||
    window.location.href.indexOf("qa2") > -1 ||
    window.location.href.indexOf("qa3") > -1 ||
    app.appEnv === DEVELOPMENT
  ) {
    calendlyLink = "https://calendly.com/agorz-contractor/15min";
  }

  //  signed locations do not have calendly
  if (!document.querySelectorAll(".js-calendly").length && !showThankYou) {
    if (!calendlyLink) {
      if ($form && $form[0].querySelector("input[name=location_id_hidden]")) {
        calendlyLink =
          "https://calendly.com/" +
          $form[0].querySelector("input[name=location_id_hidden]").value;
      }
    }

    if (calendlyLink) {
      const prefill = {
        firstName: FirstName,
        lastName: LastName,
        email: Email,
        customAnswers: {
          a1: Company,
          a2: Phone,
        },
      };

      //  listen to Calendly events
      const openModalNotCalendly = openCalendlyNotModal(
        $form,
        tourLink,
        prefill
      );
      const scheduledCallback = calendlyListener(
        formValues,
        openModalNotCalendly
      );

      calendly(calendlyLink, prefill, {
        scheduledCallback,
      });
    }
  }

  const calendlyWrapper = document.querySelectorAll(".js-calendly");
  const modal = document.querySelector(".js-modal-with-form");

  if (calendlyWrapper.length && calendlyLink && !showThankYou) {
    modal.classList.add("modal--inline-calendly");
    calendlyWrapper.forEach((elem) => {
      const iframe = elem.querySelector(".calendly-inline-widget iframe");
      if (!calendlyLink) {
        if ($form && $form[0].querySelector("input[name=location_id_hidden]")) {
          calendlyLink =
            "https://calendly.com/" +
            $form[0].querySelector("input[name=location_id_hidden]").value;
        }
      }
      if (calendlyLink) {
        iframe.setAttribute(
          "src",
          iframe
            .getAttribute("src")
            .replace("https://calendly.com/", calendlyLink)
        );

        iframe.addEventListener("load", () => {
          elem.classList.remove("d-none");
        });
      }
    });
  } else if (!showThankYou) {
    $("body").addClass("js-hide-modal");
  }
};
